import { FlosIcon, InfoBox } from '@flos/react-ui';
import { useHippoText } from '../../../../../hooks/useHippoText';
import type { CaravanOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/uvp';

const CaravanInfoBox = ({
    isCaravanFound,
    coverable
}: {
    isCaravanFound: boolean | undefined;
    coverable: CaravanOnsaDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    const getInfoBoxLabel = (): string => {
        if (isCaravanFound) {
            return 'Campingvogn';
        } else if (isCaravanFound === undefined) {
            return '';
        }
        return getHippoText('DSS-COVERABLE-INFORMATION-STEP-LICENSE-PLATE-NO-MATCH');
    };

    const getInfoBoxTitle = (): string => {
        if (isCaravanFound) {
            return `${coverable.make ?? ''} ${coverable.model ?? ''}`;
        } else if (isCaravanFound === undefined) {
            return '';
        }
        return getHippoText('DSS-COVERABLE-INFORMATION-STEP-LICENSE-PLATE-CHECK-LICENSE-PLATE');
    };

    return (
        <InfoBox
            className="u-spacing-inset-bottom-4"
            iconShape={'caravan'}
            label={getInfoBoxLabel()}
            title={getInfoBoxTitle()}
            text={isCaravanFound ? coverable.year?.toString() : ''}
            actionArea={
                isCaravanFound !== undefined && (
                    <FlosIcon
                        className={isCaravanFound ? 'is-green has-fill' : 'is-red has-fill'}
                        shape={isCaravanFound ? 'circle-check' : 'circle-close'}
                        size={'medium'}
                    />
                )
            }
        />
    );
};

export default CaravanInfoBox;
